import { useDragAndDrop } from '../contexts/useDragAndDrop';
import type { DragAndDropType } from '@app/services/aiFlow.types';

const DraggablePalette = () => {
    const { setDragItemType } = useDragAndDrop();

    const handleDragStart = (event: React.DragEvent<HTMLDivElement>, type: DragAndDropType) => {
        setDragItemType(type);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className="draggable-palette" data-testid="draggable-palette">
            <div className="margin-bottom-0">Drag to add to flow panel</div>
            <DragItem type="action" onDragStart={handleDragStart} />
            <DragItem type="decision" onDragStart={handleDragStart} />
            <DragItem type="section" onDragStart={handleDragStart} />
            <DragItem type="question" onDragStart={handleDragStart} />
        </div>
    );
};

export default DraggablePalette;

const DragItem = ({
    type,
    onDragStart,
}: {
    type: DragAndDropType;
    onDragStart: (event: React.DragEvent<HTMLDivElement>, type: DragAndDropType) => void;
}) => {
    return (
        <div
            className={`drag-item ${type}`}
            draggable
            onDragStart={(event) => onDragStart(event, type)}>
            <p>{type.charAt(0).toUpperCase() + type.slice(1)}</p>
        </div>
    );
};
